import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Partner} from "../../../shared/interface/partner";
import {Ofwca} from "../../../shared/interface/ofwca";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {of, ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {PartnerService} from "../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {delay, takeUntil, tap} from "rxjs/operators";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {$t} from "codelyzer/angular/styles/chars";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {EmailAddress} from "../../../shared/interface/email-address";
import {PhoneNumber} from "../../../shared/interface/phone-number";


export interface AddAffiliateCodeDialogData {
  partnerObject?: Partner ;
  ofwcaObject?: Ofwca;
  affiliateCodeObject?: AffiliateCode;
}
@Component({
  selector: 'app-affiliate-code-add-dialog',
  templateUrl: './affiliate-code-add-dialog.component.html',
  styleUrls: ['./affiliate-code-add-dialog.component.scss']
})
export class AffiliateCodeAddDialogComponent implements OnInit, OnDestroy {


  affiliateCodeForm: FormGroup;
  nameControl: FormControl;
  individualCodeControl: FormControl;
  firstNameControl: FormControl;
  lastNameControl: FormControl;
  emailControl: FormControl;
  phoneControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  partnerObject: Partner;
  ofwcaObject: Ofwca;
  affiliateCodeObject: AffiliateCode;
  mainControl: FormControl;
  partnerOfwca: Ofwca[] = [];
  formErrors = {};
  processingRequest = false;
  enableSaveButton = false;
  inicialized = false;
  individualCodeProvide = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);



  constructor(
    public dialogRef: MatDialogRef<AffiliateCodeAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddAffiliateCodeDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private affiliateCodeService: AffiliateCodeService,
    private snack: MatSnackBar,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
  ) {
    this.partnerObject = data.partnerObject;
    this.ofwcaObject = data.ofwcaObject;
    this.affiliateCodeObject = data.affiliateCodeObject;
    this.affiliateCodeForm = fb.group({
      name: this.nameControl = fb.control('', []),
      firstName: this.firstNameControl = fb.control('', [Validators.required]),
      lastName: this.lastNameControl = fb.control('', [Validators.required]),
      email: this.emailControl = fb.control('', [Validators.required, Validators.email]),
      phone: this.phoneControl = fb.control('', [Validators.required, validPhoneNumber()]),
      partner: this.partnerControl =  fb.control(this.partnerObject?.uuid),
      ofwca: this.ofwcaControl = fb.control(this.ofwcaObject?.uuid, [Validators.required]),
      main: this.mainControl =  fb.control(false),
      individualCode: this.individualCodeControl =  new FormControl(null,
        [  Validators.pattern(/^[a-zA-Z0-9]*$/) , Validators.minLength(5) , Validators.maxLength(10)]),
    });
    if (this.partnerObject && !this.ofwcaObject) {
      this.getOfwca();
    }
    if (this.ofwcaObject && !this.partnerObject) {
      this.partnerControl.setValue(this.ofwcaObject.partner?.uuid);
    }
  }

  ngOnInit(): void {
    if (this.affiliateCodeObject) {
      this.initialize(this.affiliateCodeObject);
    }
    if (this.ofwcaObject && !this.affiliateCodeObject){
      this.firstNameControl.setValue(this.ofwcaObject.firstName);
      this.lastNameControl.setValue(this.ofwcaObject.lastName);
      this.emailControl.setValue(( this.ofwcaObject.emails.filter((el: EmailAddress) => el.main))[0].address );
      this.phoneControl.setValue((this.ofwcaObject.phones.filter((el: PhoneNumber) => el.main))[0].number);
      this.enableSaveButton = this.affiliateCodeForm.valid;
    }
    this.affiliateCodeForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.affiliateCodeForm.valid);

    this.ofwcaControl.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
          if (!this.inicialized) {
            if (val) {
              this.ofwcaService.get(this.ofwcaControl.value)
                .subscribe((ofwca: Ofwca) => {
                  this.firstNameControl.setValue(ofwca.firstName);
                  this.lastNameControl.setValue(ofwca.lastName);
                  this.emailControl.setValue( ( ofwca.emails.filter((el: EmailAddress) => el.main))[0].address);
                  this.phoneControl.setValue((ofwca.phones.filter((el: PhoneNumber) => el.main))[0].number);
                });
            }
          }
        }
      );
  }

  initialize(affiliateCodeObject: AffiliateCode): void {
    of(affiliateCodeObject)
      .pipe(
        delay(0),
        tap(() => {
          this.inicialized = true;

          this.affiliateCodeForm.reset({
            ofwca: affiliateCodeObject.ofwca?.uuid,
            name: affiliateCodeObject.name,
            firstName: affiliateCodeObject.firstName,
            lastName: affiliateCodeObject.lastName,
            email: affiliateCodeObject.email,
            phone: affiliateCodeObject.phone,
            partner: affiliateCodeObject.partner?.uuid,
            main: affiliateCodeObject.main
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe(() => {
        this.inicialized = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.affiliateCodeForm, this.formErrors);
    this.formErrors = {};
    this.affiliateCodeService.send(this.affiliateCodeForm.value, this.affiliateCodeObject?.uuid)
      .subscribe((response: any) => {
        const status = response.hiperio?.status;
        const httpStatus = response.hiperio?.httpStatus;
        const code = response.code;

        let message = `Pomyślnie wygenerowano kod ${code}.`;

        if (status === 412) {
          message = `Kod ${code} został zapisany, ale brak konfiguracji Hiperio.`;
        } else if (status === 502) {
          message = `Kod ${code} został zapisany, ale synchronizacja z Hiperio nie powiodła się${httpStatus ? ` (HTTP ${httpStatus})` : ''}.`;
        }

        this.snack.open(message, 'Zamknij', {
          duration: status === 200 ? 3000 : 7000
        });

        this.processingRequest = false;
        this.dialogRef.close(true);

      }, (error: HttpErrorResponse) => {
        // Twoja dotychczasowa obsługa błędów bez zmian
        this.processingRequest = false;

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.affiliateCodeForm, this.formErrors);
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open('Podczas aktualizacji obiektu wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      });

    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  getOfwca(): void{
    this.partnerOfwca =  [];
    this.partnerService.getPartnerOfwca(this.partnerObject?.uuid)
      .subscribe((Ofwcas: ListResponse<Ofwca>) => {
        if (Ofwcas.total > 0) {
          Ofwcas.items.forEach((ofwca: Ofwca) => {
            this.partnerOfwca.push(ofwca);
          });
        }
      });
  }

}
